<div class="pl-pane__container--horizontal pl-pane--full-screen">
  <app-ngin-iframe path="ordered_item/list">
  </app-ngin-iframe>
</div>
